import { render } from "./SabhaProfile.vue?vue&type=template&id=8af9157c&scoped=true"
import script from "./SabhaProfile.vue?vue&type=script&lang=js"
export * from "./SabhaProfile.vue?vue&type=script&lang=js"

import "./SabhaProfile.vue?vue&type=style&index=0&id=8af9157c&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af9157c"]])

export default __exports__